import { createContext, ReactNode, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../services/Api";
import { showToast } from "../utils";

type signInDataType = {
  email: string;
  password: string;
};

type UserType = {
  email: string;
  roles: object;
};

type AuthContextType = {
  isAuthenticated: boolean;
  token: string | null;
  user: UserType;
  signIn: (data: signInDataType) => Promise<void>;
  setIsAuthenticated: (value: boolean) => void;
  setEditionModeState: (value: boolean) => void;
  editionModeState: boolean;
};

type AuthProviderProps = {
    children: ReactNode;
}

export const AuthContext = createContext({} as AuthContextType);
export function signOut() {
  localStorage.removeItem("barte-auth-token");
  localStorage.removeItem("barte-user-info");
  localStorage.removeItem("barte-features-list-user");
  window.location.replace(String(process.env.REACT_APP_FRONT_URL) + "login");
}
export function AuthProvider({ children }: AuthProviderProps) {
  let navigate = useNavigate();
  const [user, setUser] = useState<UserType>({} as UserType);
  const [editionModeState, setEditionModeState] = useState<boolean>(false);
  const token = localStorage.getItem('barte-auth-token');
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
        if(token) return true;
        return false;
  });
  
  async function signIn(data: signInDataType) {
    localStorage.removeItem("barte-auth-token");
    try {
      const login = await api.post("/public/auth/barte/sign-in", data);
      const { token, refreshToken } = login.data;
      const { email, roles } = login.data;
      localStorage.setItem("barte-auth-token", token);
      localStorage.setItem("barte-refresh-token", refreshToken);
      localStorage.setItem("barte-user-info", JSON.stringify({ email, roles }));
      setUser({ email, roles });
      //@ts-ignore
      api.defaults.headers["Authorization"] = `Bearer ${token}`;
      navigate('/seller');
      window.location.reload();
    } catch (error: any) {
      error?.response?.data?.errors?.map((error:any) => (
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`
        })
      ));
    }
    
  }

  return (
    <AuthContext.Provider value={{ user, token, isAuthenticated, setIsAuthenticated, signIn, editionModeState, setEditionModeState}}>
      {children}
    </AuthContext.Provider>
  );
}
export function useAuth(): AuthContextType {
    const context = useContext(AuthContext);
    if(!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}